export const environment = {
  production: true,
  commanHost: 'https://back.koinnation.io/',
  serviceHost: 'https://back.koinnation.io/',
  sepHost: 'https://huigyvdsklcj.mycryptosep.in/',

  // commanHost: 'http://localhost:8290/',
  // serviceHost: 'http://localhost:8290/',
  // sepHost: 'http://localhost:8099/',


  ImageuploadURL: 'https://back.koinnation.io/',
  serviceHostLIQ: 'https://back.koinnation.io/',
  stripe_publishable_key: 'pk_live_51N12JGSC6mIRQIv6rNjPcq0M7ojehClOE1o1eIbM8PjnyhGRDD2Pye8jQf0u564a5uO5wnv2sX2ZoCOjTLGGFfQB00BSJuJ5AL',
  site_name: 'KoinNation',
}
